"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: _styles.colors.sterling,
    borderRadius: '2rem',
    margin: '0 5px',
    padding: function padding(_ref) {
      var small = _ref.small;
      return small ? '3px 7px' : '4px 10px';
    }
  },
  icon: {
    flexShrink: 0,
    margin: '0 3px',
    cursor: 'pointer',
    fill: _styles.colors.ash,
    height: function height(_ref2) {
      var small = _ref2.small;
      return small ? '8px' : '10px';
    },
    width: function width(_ref3) {
      var small = _ref3.small;
      return small ? '8px' : '10px';
    }
  },
  text: {
    flexShrink: 0,
    fontSize: function fontSize(_ref4) {
      var small = _ref4.small;
      return small ? '12px' : '14px';
    },
    margin: '0 5px'
  }
};
var _default = styles;
exports["default"] = _default;